import React from 'react';

import { Button } from 'antd';

import { WhatsAppOutlined } from '@ant-design/icons';

export function SupportButton() {
    return (
        <div
            style={{
                position: 'fixed',
                bottom: 24,
                right: 24,
                zIndex: 1000,
            }}
        >
            <Button
                type="primary"
                icon={<WhatsAppOutlined />}
                size="large"
                shape="round"
                onClick={() => window.open('https://wa.me/message/2H6ZGZES463TD1', '_blank')}
            >
                            Suporte
            </Button>
        </div>
    );
}
